exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#dd-collapse {\n  border-radius: 8px;\n}\n#dd-collapse .inactive .ant-collapse-header {\n  color: #f32144 !important;\n}\n#dd-collapse .ant-collapse-header {\n  font-weight: 500;\n  font-size: 15px;\n  color: #085FCE;\n}\n#dd-collapse .ant-collapse-item:last-child, #dd-collapse .ant-collapse-content:last-child {\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n#dd-collapse #expandIcon svg {\n  transition: all 0.2s ease-in-out !important;\n}\n#dd-collapse #expandIcon.active svg {\n  transform: rotate(180deg) !important;\n}", ""]);

// exports
